import translate from './translate.json';
const compareApps = (a, b) => {
    const getCode = (str) => {
        return str.charCodeAt(0)
    }
    const usuallySort = (a, b) => {
        //console.log(a,b)
        if (b < a) {
            return 1;
        } else if (b > a) {
            return -1;
        } else {
            return 0;
        }
    }
    let sortA = parseInt(a.codeAsvulSort.replace(/[^0-9]/g, match => getCode(match)))
    let sortB = parseInt(b.codeAsvulSort.replace(/[^0-9]/g, match => getCode(match)))

    if (window.location.href.indexOf('needDebug=1') > -1) {
        console.log(sortA, sortB, a.codeasvul, b.codeasvul, sortA < sortB, sortB < sortA)
    }
    // if(a.researchmarket === "Изучается спрос" && b.researchmarket === "Изучается спрос"  ) {
    //     return 0
    // } else if (a.researchmarket === "Изучается спрос" ) {
    //     return -1;	
    // } else if 	(b.researchmarket === "Изучается спрос"){
    //     return 1;			

    if (/[0-9]/g.test(a.codeAsvulSort.slice(0, -2)) && !/[0-9]/g.test(b.codeAsvulSort.slice(0, -2))) {
        return -1;
    } else if (/[0-9]/g.test(b.codeAsvulSort.slice(0, -2)) && !/[0-9]/g.test(a.codeAsvulSort.slice(0, -2))) {
        return 1;
    }
    else if (!/[0-9]/g.test(a.codeAsvulSort.slice(0, -2)) && !/[0-9]/g.test(b.codeAsvulSort.slice(0, -2))) {
        return usuallySort(a.codeAsvulSort.toLowerCase(), b.codeAsvulSort.toLowerCase())

    } else {
        return sortA - sortB;
    }
}

const getItemFromStorage = (prop) => {
    try {
        let result = JSON.parse(localStorage.getItem(prop))
        return result || []
    } catch (error) {
        try {
            let result = JSON.parse('[' + localStorage.getItem(prop) + ']')
            return result
        } catch (error) {
            return ([])
        }
    }
}

const getStringFromStorage = (prop) => {
    try {
        let result = localStorage.getItem(prop)
        return hasProperty(result) ? result : ''
    } catch (error) {
        return ('');
    }
}


const hasProperty = (value) => {
    return !['null', null, '', undefined].includes(value)
}

const getKLOLink = () => {
    if (window.location.href.indexOf('https://catalog.cft.ru/') > - 1) {
        return 'https://lk.cft.ru'
    } else {
        let link = getStringFromStorage('KLOLink')
        return hasProperty(link) ? link : 'http://bs-data-analyze.win.ftc.ru:5050'
    }
}
const getKLOMonth = () => {
    if (window.location.href.indexOf('https://catalog.cft.ru/') > - 1) {
        return `${new Date().getMonth() < 9 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1}.${new Date().getFullYear()}`
    } else {
        let month = getStringFromStorage('KLOMonth')
        return hasProperty(month) ? month : `${new Date().getMonth() < 9 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1}.${new Date().getFullYear()}`
    }
}

const getPriceItem = (inCu, lang, type = 'elp') => {
    let cost = lang === 'Ru' ? 'тыс.' : 'K '
    let currency = '';

    if (inCu !== '1' && lang === 'Ru') {
        currency = 'руб.';
    } else if (inCu !== '1' && lang !== 'Ru') {
        currency = 'rub.';
    } else if (inCu === '1' && lang === 'Ru') {
        currency = 'у.е.';
    } else if (inCu === '1' && lang !== 'Ru') {
        currency = 'c.u.';
    }

    let month = type === 'elp' ? '' : lang === 'Ru' ? '/мес.' : '/month'

    return `${cost}${currency}${month}`
}

const copyToClipBoard = (text,callback) => {  
    navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!', text);
        if (!!callback) {
            callback()
        }
        }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}

const setDataToStorage = (prop, value) => {
    try {
        localStorage.setItem(prop, value)
        return ''//hasProperty(result) ? result : ''
    } catch (error) {
        return '';
    }
}

const getCurrentPrice =(val, lang, currency = '') => {
    if (val === null || typeof val === 'number' && val < 0) {
        return '-';
    } else if (val === 0) {
        return translate.Words[`NotCharged${lang}`];
    } else return val.toLocaleString('ru-RU', {maximumFractionDigits:3}) + currency;
                                            
}

const validateSearchVal =(val, isCatalogSearch = false) => {  
    if (isCatalogSearch) {
        val = val.replace(/%/g, "~percent~").replace(/ALTER|CREATE|DELETE|DROP|EXEC(UTE){0,1}|INSERT( +INTO){0,1}|MERGE|SELECT|UPDATE|UNION( +ALL){0,1}|;|'|"/gmi,'')
    }  else {
        val = val.replace(/ALTER|CREATE|DELETE|DROP|EXEC(UTE){0,1}|INSERT( +INTO){0,1}|MERGE|SELECT|UPDATE|UNION( +ALL){0,1}|;|'|"/gmi,'')
    }
    
    return val
}





export default { compareApps, getItemFromStorage, hasProperty,getStringFromStorage, getKLOLink,getKLOMonth, getPriceItem,copyToClipBoard,setDataToStorage,getCurrentPrice,validateSearchVal }
